import React, { memo } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import type { NRErrorInfo } from "@swiggy-private/js-utils";
import { PLWidgetController } from "@swiggy-private/dls-react-mxn";
import type { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
interface PlPopUpRendererProps {
    popupCards: IPLWidgetControllerCards[];
    onInvalidWidget: (widgetName?: string) => void;
    onWidgetError: (error: NRErrorInfo, widgetName?: string) => void;
    onEmptyPage: () => void;
}

const PlPopUpRenderer = ({
    onInvalidWidget,
    onWidgetError,
    onEmptyPage,
    popupCards,
}: PlPopUpRendererProps) => {
    if (isEmpty(popupCards)) {
        return null;
    }

    return (
        <PLWidgetController
            cards={popupCards}
            onInvalidWidget={onInvalidWidget}
            onWidgetError={onWidgetError}
            onEmptyPage={onEmptyPage}
        />
    );
};

export default memo(PlPopUpRenderer);
